import { Grid, Typography, Box, Paper } from "@mui/material"
import { CenterCardStyles, CenterTextStyles, SpinningGearsStyles } from "./styles/LoadingScreenStyles"
import SpinningGears from "../../resources/spinningGears"

function LoadingScreen() {

    return (
        <Grid container justifyContent="center">
            <Paper sx={CenterCardStyles} elevation={10}>
                <Paper elevation={0} sx={SpinningGearsStyles}>
                    <SpinningGears />
                </Paper>
                <Box sx={CenterTextStyles}>
                    <Typography variant="h3">Loading</Typography>
                </Box>
            </Paper>
        </Grid>
    )
}

export default LoadingScreen
